document.addEventListener("DOMContentLoaded", (event) => {
    // All sections visible on homepage
    document.querySelectorAll("section").forEach(function (el) {
        el.classList.add("loaded");
    });

    // Sticky header scroll class
    const navbar = document.querySelector(".top-fixed-bar");
    if (navbar) {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 50) {
                navbar.classList.add("scrolled");
            } else {
                navbar.classList.remove("scrolled");
            }
        }, { passive: true });
    }

    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, Flip);

    // ScrollSmoother (desktop only)
    if (window.innerWidth > 767) {
        ScrollSmoother.create({
            wrapper: "#smooth-wrapper",
            content: "#smooth-content",
            smooth: 2,
            normalizeScroll: true,
            ignoreMobileResize: true,
            effects: true,
            preventDefault: true
        });
    }

    // ---- MENU ANIMATION (z cięcia 02) ----
    const fullSize    = document.querySelector(".full-size");
    const menuBtn     = document.querySelector(".menu-right");
    const thumbnail   = document.querySelector(".thumbnail.in");
    const thumbnail2  = document.querySelector(".thumbnail.out");
    const menuLabel   = document.querySelector(".menu-right h6");
    const menuItems   = gsap.utils.toArray(".main-menu .menu-item");
    const topBar      = document.querySelector(".top-fixed-bar");

    if (menuBtn) {
        menuBtn.addEventListener("click", () => {
            menuBtn.classList.toggle("active");

            if (menuBtn.classList.contains("active")) {
                const state = Flip.getState(".thumbnail.in, .full-size");
                document.querySelector(".top-section").classList.toggle("active");
                fullSize.classList.toggle("active");
                topBar.classList.toggle("menu-opened");
                menuLabel.textContent = '';

                var tl1 = gsap.timeline();
                tl1.to(menuLabel, { opacity: 0, duration: 0 });
                tl1.to(menuLabel, { delay: 0.5, opacity: 1, duration: 0.5 });

                Flip.from(state, {
                    duration: 0.5,
                    fade: false,
                    absolute: true,
                    toggleClass: "flipping",
                    ease: "power1.inOut",
                    onComplete: () => {
                        thumbnail.classList.toggle("active");
                        thumbnail2.classList.toggle("active");
                        thumbnail2.classList.toggle("open");

                        var tl = gsap.timeline();
                        tl.to(".fade-in.menuimg", {
                            opacity: 1,
                            y: 0,
                            duration: 0.7,
                            ease: "power3.inOut",
                        }).then(() => {
                            menuItems.forEach((menuItem) => {
                                tl.to(menuItem, {
                                    duration: 0.3,
                                    y: 0,
                                    opacity: 1,
                                    ease: "power3.inOut",
                                }, "-=50%");
                            });
                        });
                    }
                });
            } else {
                const state = Flip.getState(".full-size, .thumbnail.out");
                thumbnail2.classList.toggle("open");

                var tl2 = gsap.timeline();
                setTimeout(() => { menuLabel.textContent = 'Menu'; }, 300);
                tl2.to(menuLabel, { delay: 0.3, opacity: 0, duration: 0 });
                tl2.to(menuLabel, { delay: 0.3, opacity: 1, duration: 0.5 });

                var tl2a = gsap.timeline();
                tl2a.to(".fade-in.menuimg", {
                    opacity: 0,
                    y: -15,
                    duration: 0.2,
                    ease: "power3.inOut",
                }).then(() => {
                    menuItems.forEach((menuItem) => {
                        tl2a.to(menuItem, {
                            duration: 0.2,
                            y: -10,
                            opacity: 0,
                            ease: "power3.inOut",
                        }, "-=50%");
                    });
                }).then(() => {
                    document.querySelector(".top-section").classList.toggle("active");
                    fullSize.classList.toggle("active");
                    topBar.classList.toggle("menu-opened");

                    Flip.from(state, {
                        duration: 0.3,
                        fade: false,
                        absolute: true,
                        toggleClass: "flipping",
                        ease: "power1.inOut",
                        onComplete: () => {
                            thumbnail.classList.toggle("active");
                            thumbnail2.classList.toggle("active");
                        }
                    });
                });
            }
        });
    }

    // ---- HERO VIDEO LOAD (z cięcia 02) ----
    if (document.querySelector(".header-section")) {
        document.querySelectorAll('.video-banner video').forEach(function (el) {
            var datasrc = el.getAttribute("data-src");
            if (datasrc) {
                el.setAttribute("src", datasrc);
                el.load();
            }
        });

        // Hero ScrollTrigger pin animation (desktop only)
        if (window.innerWidth > 768) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".header-section",
                    pin: true,
                    start: "top 0px",
                    end: "+=900",
                    scrub: true
                }
            });

            setTimeout(() => { ScrollTrigger.refresh(); }, 5000);
            setTimeout(() => { ScrollTrigger.refresh(); }, 10000);

            if (window.innerWidth <= 1200) {
                tl.to("#circle", {
                    scale: 0,
                }).from("#spiral", {
                    scale: 0.3,
                }, 0).to(".video-banner-wrapper.v2", {
                    "--circle-size": 0,
                    opacity: 0,
                    ease: "circ.in",
                    duration: 0.1,
                }, "-=80%").from(".video-banner-wrapper.v3", {
                    opacity: 0,
                }, "-=80%").to(".video-banner-wrapper.v3", {
                    opacity: 0,
                    ease: "circ.in",
                }, "-=50%");
            } else {
                tl.to("#circle", {
                    scale: 0,
                }).from("#spiral", {
                    scale: 0.3,
                }, 0).to(".video-banner-wrapper.v2", {
                    "--circle-size": 0,
                    opacity: 0,
                    ease: "circ.in",
                    duration: 0.1,
                }, "-=80%").from(".video-banner-wrapper.v3", {
                    opacity: 0,
                }, "-=80%").to(".video-banner-wrapper.v3", {
                    scale: 0,
                    opacity: 0,
                    ease: "circ.in",
                }, "-=50%");
            }
        }
    }

    // ---- SCROLL REVEAL (IntersectionObserver) ----
    const upRevealTargets = [
        ...document.querySelectorAll(".scroll-fade-in"),
        ...document.querySelectorAll(".system-card"),
        ...document.querySelectorAll(".event-item"),
        ...document.querySelectorAll(".se-item"),
        ...document.querySelectorAll(".sv-header"),
        ...document.querySelectorAll(".ne-heading"),
        ...document.querySelectorAll(".aoi-text"),
        ...document.querySelectorAll(".aoi-dark-section .btn-outline-light"),
        document.querySelector(".news-swiper"),
    ].filter(Boolean);

    const leftRevealTargets = [
        document.querySelector(".icx-intro .logo"),
        document.querySelector(".aoi-title"),
        ...document.querySelectorAll(".card2 .content"),
    ].filter(Boolean);

    const rightRevealTargets = [
        document.querySelector(".aoi-img"),
        document.querySelector(".icx-video-wrapper"),
    ].filter(Boolean);

    // Stagger delays (inline to avoid CSS specificity issues)
    [
        [".aoi-text",                           "0.2s"],
        [".aoi-dark-section .btn-outline-light","0.35s"],
        [".aoi-img",                            "0.15s"],
        [".news-swiper",                        "0.4s"],
        [".icx-video-wrapper",                  "0.15s"],
    ].forEach(([sel, delay]) => {
        const el = document.querySelector(sel);
        if (el) el.style.transitionDelay = delay;
    });
    document.querySelectorAll(".card2 .content").forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.1}s`;
    });
    document.querySelectorAll(".philosophy-cols .scroll-fade-in").forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.12}s`;
    });
    document.querySelectorAll(".advantage-cols .scroll-fade-in").forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.09}s`;
    });
    document.querySelectorAll(".se-item").forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.1}s`;
    });

    if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });

        upRevealTargets.forEach((el) => { el.classList.add("reveal-on-scroll"); observer.observe(el); });
        leftRevealTargets.forEach((el) => { el.classList.add("reveal-from-left"); observer.observe(el); });
        rightRevealTargets.forEach((el) => { el.classList.add("reveal-from-right"); observer.observe(el); });
    } else {
        [...upRevealTargets, ...leftRevealTargets, ...rightRevealTargets].forEach((el) => el.classList.add("is-visible"));
    }

    // ---- PAGE HEADER entrance (subpages) ----
    const pageHeaderH1 = document.querySelector(".page-header h1");
    if (pageHeaderH1) {
        gsap.from(pageHeaderH1, {
            opacity: 0,
            y: 28,
            duration: 0.9,
            ease: "power3.out",
            delay: 0.1,
        });
    }

    // ---- ICX INTRO h2 — appear from bottom ----
    const icxIntroH2 = document.querySelector(".icx-intro .left h2");
    if (icxIntroH2) {
        gsap.from(icxIntroH2, {
            opacity: 0,
            y: 40,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: {
                trigger: icxIntroH2,
                start: "top 90%",
                toggleActions: "play none none none",
            },
        });
    }

    // ---- NEWS LIST / EVENTS LIST items ----
    function animateListItems(items) {
        let visibleCount = 0;
        items.forEach((item) => {
            const inView = item.getBoundingClientRect().top < window.innerHeight * 0.85;
            const delay = inView ? visibleCount * 0.15 : 0;
            if (inView) visibleCount++;

            gsap.fromTo(item,
                { y: 28 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.9,
                    ease: "power3.out",
                    delay,
                    clearProps: "transform",
                    scrollTrigger: {
                        trigger: item,
                        start: "top 85%",
                        once: true,
                    },
                }
            );
        });
    }

    const newsItems = gsap.utils.toArray(".news-list > .item");
    const eventItems = gsap.utils.toArray(".events-list .item");
    const dlItems = gsap.utils.toArray(".dl .list .item");
    if (newsItems.length) animateListItems(newsItems);
    if (eventItems.length) animateListItems(eventItems);
    if (dlItems.length) animateListItems(dlItems);

    // ---- FOOTER-TOP columns (ScrollTrigger — stagger po kolei) ----
    const footerLogoCol = document.querySelector(".footer-top > div:first-child");
    const footerNavCols = gsap.utils.toArray(".footer-top > div:nth-child(2) > .row > div");
    const footerEls = [footerLogoCol, ...footerNavCols].filter(Boolean);
    if (footerEls.length) {
        gsap.fromTo(footerEls,
            { opacity: 0, y: 28 },
            {
                opacity: 1,
                y: 0,
                duration: 0.55,
                stagger: 0.08,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".site-footer",
                    start: "top 88%",
                    once: true,
                }
            }
        );
    }

    // ---- IMG-COL images — width reveal (desktop) / fade-in (mobile) ----
    if (window.innerWidth < 576) {
        gsap.utils.toArray(".img-col > img").forEach((img) => {
            gsap.fromTo(img,
                { opacity: 0 },
                {
                    opacity: 1,
                    duration: 1,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: img,
                        start: "top 85%",
                        once: true,
                    }
                }
            );
        });
    }
    if (window.innerWidth >= 576) gsap.utils.toArray(".img-col > img").forEach((img) => {
        gsap.fromTo(img,
            { width: 0 },
            {
                width: "100%",
                duration: 1.2,
                ease: "power2.inOut",
                scrollTrigger: {
                    trigger: img,
                    start: "top 80%",
                    once: true,
                }
            }
        );
    });

    // ---- MAP — fade in ----
    if (document.querySelector(".map object")) {
        gsap.fromTo(".map object",
            { opacity: 0 },
            {
                opacity: 1,
                duration: 2.5,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".map object",
                    start: "center bottom",
                    once: true,
                }
            }
        );
    }

    // ---- AOI DARK SECTION — circle reveal ----
    if (document.querySelector(".aoi-dark-section")) {
        gsap.fromTo(".aoi-dark-section",
            { "--aoi-radius": 0 },
            {
                "--aoi-radius": 150,
                ease: "none",
                scrollTrigger: {
                    trigger: ".aoi-dark-section",
                    start: "top 75%",
                    end: "center top",
                    scrub: true,
                }
            }
        );
    }

    // ---- SPLITTEXT LINE ANIMATIONS ----
    setTimeout(() => {
        if (document.querySelector(".icx-intro .texts")) {
            const introChildSplit = new SplitText(".icx-intro .texts p", {
                type: "lines",
                linesClass: "split-child"
            });
            new SplitText(".icx-intro .texts p", {
                type: "lines",
                linesClass: "split-parent"
            });
            gsap.set(".icx-intro .texts p", { opacity: 0.9 });
            ScrollTrigger.refresh();
            const catalogTrigger = document.querySelector(".icx-intro .right");
            if (catalogTrigger) {
                const belowFold = catalogTrigger.getBoundingClientRect().top > window.innerHeight;
                gsap.fromTo([".right .top", ".right .img", ".right .bottom"],
                    { opacity: 0, y: 28 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.6,
                        ease: "power2.out",
                        stagger: 0.1,
                        scrollTrigger: {
                            trigger: ".icx-intro .right",
                            start: belowFold ? "top 70%" : "top 90%",
                            toggleActions: "play none none none"
                        }
                    }
                );
            }
            gsap.from(introChildSplit.lines, {
                scrollTrigger: {
                    trigger: ".icx-intro",
                    start: "top 90%",
                    toggleActions: "play none none none"
                },
                duration: 0.8,
                yPercent: 100,
                ease: "power4",
                stagger: 0.15
            });
        }

        const gabinetTitle = document.querySelector(".gabinety-section .title");
        if (gabinetTitle) {
            const gabinetCharSplit = new SplitText(gabinetTitle, {
                type: "chars,words"
            });
            gsap.from(gabinetCharSplit.chars, {
                scrollTrigger: {
                    trigger: ".gabinety-section",
                    start: "top 85%",
                    toggleActions: "play none none none"
                },
                opacity: 0,
                duration: 0.4,
                ease: "power2.out",
                stagger: 0.04
            });
        }

        gsap.utils.toArray(".hero.v2").forEach((section) => {
            const sub = section.querySelector(".sub");
            if (!sub) return;
            const subChildSplit = new SplitText(sub, { type: "lines", linesClass: "split-child" });
            new SplitText(sub, { type: "lines", linesClass: "split-parent" });
            gsap.set(sub, { opacity: 1 });
            gsap.from(subChildSplit.lines, {
                scrollTrigger: {
                    trigger: section,
                    start: "top 85%",
                    toggleActions: "play none none none"
                },
                duration: 0.8,
                yPercent: 100,
                ease: "power4",
                stagger: 0.15
            });
        });
    }, 500);

    gsap.utils.toArray(".hero.v2").forEach((section) => {
        const title = section.querySelector("h2");
        if (title) {
            const charSplit = new SplitText(title, { type: "chars,words" });
            gsap.set(title, { opacity: 1 });
            gsap.fromTo(charSplit.chars,
                { opacity: 0 },
                {
                    scrollTrigger: {
                        trigger: section,
                        start: "top 85%",
                        toggleActions: "play none none none"
                    },
                    opacity: 1,
                    duration: 0.4,
                    ease: "power2.out",
                    stagger: 0.04
                }
            );
        }

        const eyebrow = section.querySelector(".eyebrow");
        if (eyebrow) {
            gsap.fromTo(eyebrow,
                { opacity: 0 },
                {
                    scrollTrigger: {
                        trigger: section,
                        start: "top 85%",
                        toggleActions: "play none none none"
                    },
                    opacity: 1,
                    duration: 1.8,
                    delay: 1,
                    ease: "power2.out"
                }
            );
        }

        const stats = section.querySelectorAll(".stat");
        if (stats.length) {
            gsap.fromTo(stats,
                { opacity: 0, x: 40 },
                {
                    scrollTrigger: {
                        trigger: section,
                        start: "top 85%",
                        toggleActions: "play none none none"
                    },
                    opacity: 1,
                    x: 0,
                    duration: 0.5,
                    ease: "power2.out",
                    stagger: 0.1
                }
            );
        }
    });

    // ---- HERO v2 .img — Spiral clip-path wipe (proporcje 1:1) ----
    gsap.utils.toArray('.hero.v2 .img').forEach((img) => {
        const section = img.closest('.hero.v2');
        if (!section) return;

        const turns = 5;
        const N = 300;
        let scaleX = 1, scaleY = 1;

        function buildSpiralPath(p) {
            if (p >= 1) return 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
            const count = Math.ceil(N * p);
            if (count === 0) return 'polygon(50% 50%, 50% 50%, 50% 50%)';
            const pts = ['50% 50%'];
            for (let i = 0; i <= count; i++) {
                const angle = (i / N) * turns * 2 * Math.PI - Math.PI / 2;
                const r = i / N; // 0..1
                pts.push(
                    (50 + r * scaleX * Math.cos(angle)).toFixed(2) + '% ' +
                    (50 + r * scaleY * Math.sin(angle)).toFixed(2) + '%'
                );
            }
            return 'polygon(' + pts.join(', ') + ')';
        }

        img.style.clipPath = buildSpiralPath(0);

        const state = { p: 0 };
        gsap.to(state, {
            p: 1,
            duration: 4,
            ease: 'power4.out',
            onStart() {
                // Oblicz skalowanie tak, żeby spirala była kołem w pikselach
                const W = img.offsetWidth  || 600;
                const H = img.offsetHeight || 400;
                const diag = Math.sqrt(W * W + H * H) / 2 * 1.1;
                scaleX = diag / W * 100;
                scaleY = diag / H * 100;
            },
            onUpdate() { img.style.clipPath = buildSpiralPath(state.p); },
            onComplete() { img.style.clipPath = ''; },
            scrollTrigger: {
                trigger: section,
                start: 'top 80%',
                once: true,
            }
        });
    });

    /* setTimeout(() => {
        if (document.querySelector(".icx-intro .texts")) {
            const introChildSplit = new SplitText(".icx-intro .texts p", {
                type: "lines",
                linesClass: "split-child"
            });
            new SplitText(".icx-intro .texts p", {
                linesClass: "split-parent"
            });
            gsap.from(introChildSplit.lines, {
                scrollTrigger: {
                    trigger: ".icx-intro",
                    start: window.innerWidth < 576 ? "top 55%" : "top 70%",
                    end: "top 10%",
                    scrub: true
                },
                duration: 5,
                yPercent: 100,
                ease: "power4",
                stagger: 1
            });
        }

        const gabinetTitle = document.querySelector(".gabinety-section .title");
        if (gabinetTitle) {
            const gabinetChildSplit = new SplitText(gabinetTitle, {
                type: "lines",
                linesClass: "split-child"
            });
            new SplitText(gabinetTitle, {
                type: "lines",
                linesClass: "split-parent"
            });
            gsap.from(gabinetChildSplit.lines, {
                scrollTrigger: {
                    trigger: ".gabinety-section",
                    start: "top 85%",
                    end: "top 15%",
                    scrub: true
                },
                duration: 5,
                yPercent: 100,
                ease: "power4",
                stagger: 1
            });
        }
    }, 500); */

    // ---- SWIPER — Nowości carousel ----
    if (typeof Swiper !== "undefined") {
        const newsSwiper = document.querySelector(".news-swiper");
        if (newsSwiper) {
            const swiperInstance = new Swiper(".news-swiper", {
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".news-swiper .swiper-button-next",
                    prevEl: ".news-swiper .swiper-button-prev",
                },
                pagination: {
                    el: ".news-swiper .swiper-pagination",
                    clickable: true,
                },
                slidesPerView: 1,
                spaceBetween: 0,
            });
            swiperInstance.autoplay.stop();

            ScrollTrigger.create({
                trigger: newsSwiper,
                start: "top 50%",
                onEnter: () => { swiperInstance.autoplay.start(); },
                once: true,
            });
        }
    }

    // Leaflet map
    if (document.querySelector('#contact-map')) {
        L.Icon.Default.mergeOptions({
            iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
            iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
            shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
        });

        var ColorIcon = L.icon({
            iconUrl: 'assets/img/geo-alt-fill.svg',
            iconSize: [35, 56]
        });

        var lat = 50.361350;
        var lon = 18.935570;

        var map = L.map('contact-map', {
            center: [lat, lon],
            zoom: 14,
            zoomControl: false,
            minZoom: 1
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
        }).addTo(map);

        L.control.zoom({
            position: 'bottomright'
        }).addTo(map);

        L.marker([lat, lon], {icon: ColorIcon}).addTo(map)
            .bindPopup("<b>ul. Stara 7</b><br>41-940 Piekary Śląskie")
            .openPopup();
    }
});
